import { motion } from "framer-motion";
import { Info } from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";

export default function StatBig({ overline, title, items, disclaimer }) {
  return (
    <section className="bg-ink text-white py-20 md:py-28" data-testid="stat-big">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <Reveal>
          <Overline>{overline}</Overline>
          <h2 className="mt-4 font-serif font-semibold text-3xl sm:text-4xl md:text-5xl tracking-tight max-w-2xl leading-[1.08] text-white">
            {title}
          </h2>
        </Reveal>

        <div className="mt-14 grid gap-6 md:grid-cols-3">
          {items.map((m, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ type: "spring", stiffness: 240, damping: 24, delay: i * 0.1 }}
              className="rounded-2xl border border-white/10 bg-white/[0.03] p-8"
            >
              <div className="font-serif font-semibold text-5xl md:text-6xl tracking-tight leading-none text-brand">
                {m.big}
              </div>
              <p className="mt-4 text-white/60 text-sm uppercase tracking-[0.12em]">{m.small}</p>
            </motion.div>
          ))}
        </div>

        {disclaimer && (
          <Reveal delay={0.1} className="mt-8 flex items-start gap-2 text-sm text-white/50 max-w-3xl">
            <Info size={16} className="mt-0.5 shrink-0" />
            <span>{disclaimer}</span>
          </Reveal>
        )}
      </div>
    </section>
  );
}
